export function isMobileSafari(): boolean {
  try {
    const ua = navigator.userAgent || '';
    return /iP(hone|ad|od)/.test(ua) && /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS/.test(ua);
  } catch { return false; }
}

export function canUseRealtimeWS(): boolean {
  try {
    // must be https + present WebSocket + secureContext, and allow an opt-out via env
    const https = typeof location !== 'undefined' && location.protocol === 'https:';
    const hasWS = typeof WebSocket !== 'undefined';
    const secureCtx = typeof window !== 'undefined' && (window as any).isSecureContext !== false;
    const disabledByEnv = import.meta.env.VITE_DISABLE_REALTIME === '1';
    return https && hasWS && secureCtx && !disabledByEnv;
  } catch { return false; }
}

export const CAN_USE_REALTIME = canUseRealtimeWS();